import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, withStyles } from '@material-ui/core';

const styles = theme => ({
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.error.dark,
        borderRadius: '1px'
    },
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark,
        borderRadius: '1px'
    }
});

const TransportColliDelete = props => {
    let { classes, unpairedExternal, translations, handleCloseDanger, handleCloseSafe } = props;

    return (
        <Dialog
            open={unpairedExternal.open}
            onClose={handleCloseSafe}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">{unpairedExternal.forBulk ? translations['bulk_unpaired'] || 'Bulk unpaired ' : translations['unpaired'] || ' Unpaired '}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {translations['careful_when_doing'] || 'Be careful when doing this'}.<br />
                    {translations['you_want_to_unpair'] || ' You want to unpair'} {unpairedExternal.forBulk ? translations['externals_data'] || 'these external data' : translations['external_data'] || 'this external data'} ?
           </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className={classes.buttonSafe} onClick={handleCloseSafe} variant="contained" >
                    {translations['no'] || 'No'}
                </Button>
                <Button className={classes.buttonDanger} onClick={handleCloseDanger} variant="contained">
                    {translations['yes'] || 'Yes'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default withStyles(styles, { withTheme: true })(TransportColliDelete);